export default __webpack_public_path__ + "static/media/xillon.56b599d0.webp";